import React from 'react';
import { Nav, MainContent } from './component';
import '@fontsource/noto-sans';
import './App.css';
import MusicPlayerState from './component/context/MuiscPlayerState';
import { IMainProps } from './main.types';

export const Main = (props:  IMainProps) => {

const { getSongData, isLoading } = props

  return (
    <MusicPlayerState>
      <div className='epidemic-plugin-container'>
        <div className='epidemic-plugin'>
          <Nav />
          <MainContent getSongData={getSongData}  isLoading={isLoading} />
        </div>
      </div>
    </MusicPlayerState>
  )
}